var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wc-tabbar-cart"}},[_c('v-badge',{attrs:{"value":_vm.cartCount,"content":_vm.cartCount,"offset-y":"8.88"}},[_c('v-icon',{attrs:{"size":"28px"},on:{"click":_vm.onClickShoppingCart}},[_vm._v(" mdi-cart-outline ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }